import { VNode, Ref } from 'vue';

type Node = string|VNode|Array<Node>;

export const vif = (cond: boolean) => <T extends Node>(x: T) => cond ? x : '';
export const vif1 = (cond: boolean) => <T extends Node>(f: () => T) => cond ? f() : '';
export const vif2 = (cond: () => boolean) => <T extends Node>(f: () => T) => cond() ? f() : '';
export const set = <T>(x: Ref<T>) => (v: T) => x.value = v;
